import { generateRandomNumber } from "./numbers";
import env from "./env";

/*
  Tracking events are sent back to piwik to monitor user behavior.

  There are two events that the websdk explicitly sends back to piwik:
  1. screenChanges
  2. trackingEvent actions

  Screen Changes are added to the redux store, and sent back to the flow-ui in batches.  This
  mimics the mobile applications.

  Tracking Events are sent immediately back to piwik.
  The Flow UI responses contain an array of actions.
  The trackingEvents are located here.
 */

function buildTrackingEvent({
  userId,
  screenName,
  eventAction = "Screen view"
}) {
  return {
    idsite: env("ID_SITE"),
    apiv: 1,
    cdt: Date(),
    dimension2: "web",
    e_a: eventAction,
    e_c: "WEBSDK",
    e_n: screenName,
    rand: generateRandomNumber(),
    rec: 1,
    send_image: "0",
    uid: userId,
    event: "rav.screenview"
  };
}

// Next block for AB test event preparing. Can be removed after testing.
const DIMENTIONS_IDS = {
  consult_id: "11",
  testname: "28",
  group: "29",
  type: "32"
};

const getEvent = data => {
  if (data?.display?.piwikEvent?.dimensions) {
    const { dimensions = [], event = "" } = data.display.piwikEvent;
    return Object.keys(DIMENTIONS_IDS).reduce(
      (prev, key) => {
        const dimensionValue = dimensions.find(
          dimension => "" + dimension.id === DIMENTIONS_IDS[key]
        )?.value;
        return dimensionValue !== undefined
          ? { ...prev, [key]: dimensionValue }
          : prev;
      },
      { event }
    );
  }
};

export { buildTrackingEvent, getEvent };
